import { render, staticRenderFns } from "./ModuleApp.vue?vue&type=template&id=570d8772&scoped=true&"
import script from "./ModuleApp.vue?vue&type=script&lang=js&"
export * from "./ModuleApp.vue?vue&type=script&lang=js&"
import style0 from "./ModuleApp.vue?vue&type=style&index=0&id=570d8772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d8772",
  null
  
)

export default component.exports